<template>
  <div
    class="portfolio-pages-wrapper section-space--ptb_100 border-bottom gray-gradient"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div
            class="section-title-wrapper text-center section-space--mb_60 wow move-up"
          >
            <h2 class="section-title font-weight--bold mb-15">Our Partners</h2>
            <h6>
              Because we can't go it all alone, we create various strategic
              synergies with our esteemed partners some of whom include, but not
              limited to:
            </h6>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div
          class="col-lg-4 col-md-6 wow move-up mb-30"
          v-for="(partner, key) in partners"
          :key="key"
        >
          <div
            class="portfolio-grid-caption text-center justify-content-center align-items-center"
          >
            <a
              :href="partner.website"
              target="_blank"
              class="single-grid-caption"
            >
              <div class="single-portfolio__thumbnail">
                <img
                  class="img-fluid"
                  :src="partner.image"
                  :alt="partner.name"
                />
              </div>
            </a>
            <div class="post-info">
              <div class="post-categories">
                <router-link to="">{{ partner.name }}</router-link>
              </div>
              <h5 class="post-title font-weight--bold">
                <router-link to="">
                  {{ partner.name }}
                </router-link>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partners from "../data/partners";

export default {
  components: {},

  data() {
    return {
      partners,
    };
  },
};
</script>
